import React from 'react';

interface WidgetToolbarProps {
  /** Left-side controls (inputs, filters, etc.) */
  leftControls?: React.ReactNode;
  /** Center controls (view toggles, etc.) */
  centerControls?: React.ReactNode;
  /** Close handler */
  onClose: () => void;
  /** Additional classes */
  className?: string;
}

/**
 * Standardized widget toolbar with consistent layout:
 * [Left Controls] ... [Center Controls] ... [Close Button]
 *
 * Always places close button on the right. Enforces z-20 for click handling.
 */
export const WidgetToolbar: React.FC<WidgetToolbarProps> = ({
  leftControls,
  centerControls,
  onClose,
  className = '',
}) => {
  return (
    <div
      className={`flex items-center px-3 py-1 bg-dark-bg/50 border-b border-dark-border relative z-20 ${className}`}
    >
      {/* Left controls */}
      {leftControls && <div className="flex items-center gap-2 flex-shrink-0">{leftControls}</div>}

      {/* Spacer */}
      <div className="flex-1" />

      {/* Center controls */}
      {centerControls && (
        <div className="flex items-center gap-1 flex-shrink-0">{centerControls}</div>
      )}

      {/* Spacer */}
      <div className="flex-1" />

      {/* Close button - always on right */}
      <button
        onClick={onClose}
        className="text-gray-400 hover:text-white hover:bg-bear-red/20 text-sm px-2 py-0.5 rounded transition-colors flex-shrink-0"
        title="Close widget"
      >
        ×
      </button>
    </div>
  );
};
